import React from 'react'
import { Circle, CircleSVG, PulseBeacon } from './index.style'

type Props = {
  color: string,
  size: number,
}

const PulsatingCircle = ({ color, size }: Props) => {
  return (
    <CircleSVG className="PulseCircle" size={size}>
      <Circle color={color} cx="50%" cy="50%" r={size / 10 + 'em'} />
      <PulseBeacon
        className="pulse-beacon"
        cx="50%"
        cy="50%"
        r={size / 3.6 + 'em'}
        color={color}
      />
    </CircleSVG>
  )
}

export default PulsatingCircle



// WEBPACK FOOTER //
// ./src/components/PulsatingCircle/index.js